import React from "react";
import { Helmet } from "react-helmet";

export default function HaryanaSoftwareCompanyPage() {

  const services = [
    {
      title: "Website Development",
      desc: "Modern responsive business websites, landing pages, SEO optimized websites, and enterprise web applications.",
      icon: "🌐",
    },
    {
      title: "SEO Services",
      desc: "Technical SEO, Local SEO, Semantic SEO, Google ranking optimization, and organic traffic growth strategies.",
      icon: "🚀",
    },
    {
      title: "App Development",
      desc: "Android app development, iOS app development, Flutter apps, and scalable mobile applications.",
      icon: "📱",
    },
    {
      title: "Custom Software",
      desc: "ERP software, CRM systems, HRMS software, billing software, and custom business solutions.",
      icon: "💻",
    },
    {
      title: "Digital Marketing",
      desc: "Google Ads, social media marketing, lead generation campaigns, and performance marketing systems.",
      icon: "📈",
    },
    {
      title: "eCommerce Development",
      desc: "Shopify stores, WooCommerce development, custom eCommerce platforms, and scalable online stores.",
      icon: "🛒",
    },
  ];

  const industries = [
    "Software Solutions for Startups",
    "ERP Software for Businesses",
    "Healthcare Website Development",
    "School Management Software",
    "CRM Software Solutions",
    "Real Estate Digital Marketing",
    "Manufacturing Software Solutions",
    "eCommerce Website Development",
  ];

  const faqs = [
    {
      q: "Why choose SoftCoders in Haryana?",
      a: "SoftCoders provides high-performance websites, SEO services, mobile app development, and software solutions designed for long-term business growth.",
    },
    {
      q: "Do you provide SEO services in Haryana?",
      a: "Yes. We provide technical SEO, local SEO, semantic SEO, content optimization, and Google ranking services.",
    },
    {
      q: "Do you build Android and iOS apps?",
      a: "Yes. We develop Android apps, iOS apps, Flutter apps, and React Native mobile applications.",
    },
    {
      q: "Do you provide ERP and CRM software?",
      a: "Yes. We develop ERP software, CRM systems, HRMS software, and custom automation platforms.",
    },
  ];

  return (
    <div className="bg-[#050816] text-white overflow-hidden">

      
  <Helmet>

    {/* PRIMARY SEO */}
    <title>
      Best Software Company in Haryana | Website, App & SEO Services | SoftCoders
    </title>

    <meta
      name="description"
      content="SoftCoders is a software company in Haryana providing website development, mobile app development, SEO services, ERP software, CRM systems, digital marketing, eCommerce development, and custom software solutions for startups and businesses."
    />

    <meta
      name="keywords"
      content="
      software company in haryana,
      best software company haryana,
      website development company haryana,
      seo company haryana,
      app development company haryana,
      digital marketing company haryana,
      custom software development,
      erp software company,
      crm software development,
      ecommerce website development,
      mobile app development company,
      android app development,
      ios app development,
      react js development,
      next js development,
      seo services company,
      local seo services,
      technical seo services,
      software development company india,
      web development company,
      business software solutions,
      startup software company,
      enterprise software solutions,
      haryana it company,
      software solutions for businesses,
      custom web applications,
      cloud software systems,
      ui ux design services,
      online business solutions,
      digital growth company
      "
    />

    <meta name="author" content="SoftCoders" />
    <meta name="robots" content="index, follow" />
    <meta name="language" content="English" />
    <meta name="revisit-after" content="2 days" />

    {/* CANONICAL */}
    <link
      rel="canonical"
      href="https://softcoders.in/software-company-haryana"
    />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="Best Software Company in Haryana | SoftCoders"
    />

    <meta
      property="og:description"
      content="Website development, mobile app development, SEO services, ERP software, CRM systems, and digital marketing solutions in Haryana."
    />

    <meta
      property="og:url"
      content="https://softcoders.in/software-company-haryana"
    />

    <meta property="og:type" content="website" />

    <meta
      property="og:image"
      content="https://softcoders.in/og-haryana-software-company.jpg"
    />

    {/* TWITTER SEO */}
    <meta name="twitter:card" content="summary_large_image" />

    <meta
      name="twitter:title"
      content="Best Software Company in Haryana | SoftCoders"
    />

    <meta
      name="twitter:description"
      content="Professional website development, app development, SEO services, ERP software, and digital marketing solutions in Haryana."
    />

    <meta
      name="twitter:image"
      content="https://softcoders.in/og-haryana-software-company.jpg"
    />

    {/* GEO SEO */}
    <meta name="geo.region" content="IN-HR" />
    <meta name="geo.placename" content="Haryana" />
    <meta name="geo.country" content="India" />

    {/* MOBILE SEO */}
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1"
    />

    <meta
      name="theme-color"
      content="#050816"
    />

    {/* SCHEMA */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "SoftwareCompany",
        name: "SoftCoders",
        url: "https://softcoders.in",
        logo: "https://softcoders.in/logo.png",
        image: "https://softcoders.in/og-haryana-software-company.jpg",
        description:
          "SoftCoders provides website development, app development, SEO services, ERP software, CRM systems, and digital marketing solutions in Haryana.",
        address: {
          "@type": "PostalAddress",
          addressRegion: "Haryana",
          addressCountry: "India"
        },
        areaServed: {
          "@type": "State",
          name: "Haryana"
        },
        sameAs: [
          "https://www.facebook.com/",
          "https://www.instagram.com/",
          "https://www.linkedin.com/"
        ],
        service: [
          {
            "@type": "Service",
            name: "Website Development"
          },
          {
            "@type": "Service",
            name: "SEO Services"
          },
          {
            "@type": "Service",
            name: "App Development"
          },
          {
            "@type": "Service",
            name: "ERP Software Development"
          },
          {
            "@type": "Service",
            name: "CRM Software Development"
          },
          {
            "@type": "Service",
            name: "Digital Marketing"
          }
        ]
      })}
    </script>

    {/* FAQ SCHEMA */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "Why choose SoftCoders in Haryana?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "SoftCoders provides high-performance websites, SEO services, mobile app development, and software solutions designed for long-term business growth."
            }
          },
          {
            "@type": "Question",
            name: "Do you provide SEO services in Haryana?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. We provide technical SEO, local SEO, semantic SEO, content optimization, and Google ranking services."
            }
          },
          {
            "@type": "Question",
            name: "Do you build Android and iOS apps?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. We develop Android apps, iOS apps, Flutter apps, and React Native mobile applications."
            }
          },
          {
            "@type": "Question",
            name: "Do you provide ERP and CRM software?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. We develop ERP software, CRM systems, HRMS software, and custom automation platforms."
            }
          }
        ]
      })}
    </script>

  </Helmet>

      {/* ====================================
              CUSTOM ANIMATIONS
      ==================================== */}
      <style>{`

        html {
          scroll-behavior: smooth;
        }

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(60px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%,100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        @keyframes glow {
          0%,100% {
            opacity: .5;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.08);
          }
        }

        .fade-up {
          animation: fadeUp 1s ease forwards;
        }

        .float {
          animation: float 7s ease-in-out infinite;
        }

        .glow {
          animation: glow 7s ease infinite;
        }

      `}</style>

      {/* ====================================
              HERO SECTION (SHORT)
      ==================================== */}
      <section className="relative overflow-hidden flex items-center border-b border-white/10 py-20">

        {/* BACKGROUND */}
        <div className="absolute inset-0 bg-[#050816]" />

        {/* GRID */}
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage: `
              linear-gradient(rgba(99,102,241,.35) 1px, transparent 1px),
              linear-gradient(90deg, rgba(99,102,241,.35) 1px, transparent 1px)
            `,
            backgroundSize: "80px 80px",
          }}
        />

        {/* GLOW */}
        <div className="absolute top-[-180px] left-[-120px] w-[500px] h-[500px] rounded-full bg-indigo-600/20 blur-3xl glow"></div>
        <div className="absolute bottom-[-180px] right-[-120px] w-[500px] h-[500px] rounded-full bg-cyan-500/10 blur-3xl glow"></div>

        {/* MAIN */}
        <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 w-full">

          <div className="fade-up text-center max-w-4xl mx-auto">

            {/* BADGE */}
            <div className="inline-flex items-center gap-3 px-5 py-2 rounded-full border border-indigo-500/20 bg-indigo-500/10 backdrop-blur-xl">
              <div className="w-2 h-2 rounded-full bg-indigo-400 animate-pulse"></div>
              <span className="text-indigo-300 text-sm font-medium tracking-wide">
                Best Software Company in Haryana
              </span>
            </div>

            {/* HEADING */}
            <h1 className="mt-6 text-4xl sm:text-5xl md:text-6xl font-black leading-[1.05] tracking-tight">
              Build Powerful
              <span className="block bg-gradient-to-r from-indigo-400 via-cyan-400 to-indigo-200 text-transparent bg-clip-text">
                Websites, Apps & SEO Systems
              </span>
              That Grow Businesses
            </h1>

            {/* DESC */}
            <p className="mt-6 text-lg text-slate-400 max-w-2xl mx-auto leading-8">
              SoftCoders is a leading software company in Haryana specializing in
              website development, mobile app development, SEO services, ERP software,
              CRM systems, and digital marketing for startups and growing businesses.
            </p>

            {/* BUTTONS */}
            <div className="flex flex-wrap justify-center gap-5 mt-8">
              <a
    href="https://wa.me/919254147455?text=Hello%20SoftCoders%2C%20I%20want%20to%20discuss%20my%20project."
    target="_blank"
    rel="noopener noreferrer"
 className="group relative overflow-hidden bg-indigo-600 hover:bg-indigo-500 px-8 py-4 rounded-2xl font-bold transition-all duration-300 hover:-translate-y-1 shadow-[0_20px_60px_rgba(99,102,241,0.35)]">
                <span className="relative z-10">Get Free Consultation</span>
                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-cyan-500 opacity-0 group-hover:opacity-100 transition duration-300"></div>
              </a>

             <a
    href="/portfolio"
 className="border border-white/10 hover:border-indigo-500/30 hover:bg-indigo-500/10 transition-all duration-300 px-8 py-4 rounded-2xl text-slate-300 hover:-translate-y-1">
                View Portfolio
              </a>
            </div>

            {/* STATS */}
            <div className="flex justify-center gap-12 sm:gap-20 mt-12">
              {[
                ["500+", "Projects"],
                ["120+", "Clients"],
                ["680%", "SEO Growth"],
              ].map(([num, label], i) => (
                <div key={i}>
                  <div className="text-3xl sm:text-4xl font-black text-indigo-400">{num}</div>
                  <div className="text-slate-500 text-sm mt-1">{label}</div>
                </div>
              ))}
            </div>

          </div>

        </div>

      </section>

      {/* ====================================
              SERVICES
      ==================================== */}
      <section className="py-24 border-b border-white/5">

        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">

          <div className="text-center max-w-3xl mx-auto">

            <div className="text-indigo-400 uppercase tracking-[0.2em] text-sm font-semibold">
              OUR SERVICES
            </div>

            <h2 className="text-4xl sm:text-5xl font-black mt-6 leading-tight">

              Full-Service Software &
              <span className="block text-indigo-400">
                Digital Solutions
              </span>

            </h2>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-20">

            {services.map((service, i) => (

              <div
                key={i}
                className="group bg-[#0E142B] border border-white/10 rounded-3xl p-8 hover:border-indigo-500/30 hover:-translate-y-3 transition-all duration-500"
              >

                <div className="text-5xl mb-6">
                  {service.icon}
                </div>

                <h3 className="text-2xl font-bold mb-4 group-hover:text-indigo-300 transition">
                  {service.title}
                </h3>

                <p className="text-slate-400 leading-8">
                  {service.desc}
                </p>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* ====================================
              INDUSTRIES
      ==================================== */}
      <section className="py-24 border-b border-white/5">

        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">

          <div className="max-w-3xl">

            <div className="text-indigo-400 uppercase tracking-[0.2em] text-sm font-semibold">
              INDUSTRIES WE SERVE
            </div>

            <h2 className="text-4xl sm:text-5xl font-black mt-6 leading-tight">

              Technology Solutions
              <span className="block text-indigo-400">
                For Every Industry
              </span>

            </h2>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">

            {industries.map((item, i) => (

              <div
                key={i}
                className="bg-[#0E142B] border border-white/10 rounded-2xl p-6 hover:border-indigo-500/30 hover:-translate-y-2 transition-all duration-300"
              >

                <h3 className="font-bold text-lg leading-8">
                  {item}
                </h3>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* ====================================
              SEO CONTENT
      ==================================== */}
      <section className="py-24 border-b border-white/5">

        <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-10">

          <h2 className="text-4xl sm:text-5xl font-black leading-tight">

            Best Software Company in Haryana

          </h2>

          <div className="space-y-8 text-slate-400 text-lg leading-9 mt-12">

            <p>

              SoftCoders is one of the best software companies in Haryana
              providing website development,
              mobile app development,
              SEO services,
              ERP software,
              CRM systems,
              custom software development,
              and digital marketing services
              for startups, enterprises,
              and local businesses.

            </p>

            <p>

              Our team of website developers,
              SEO experts,
              app developers,
              UI/UX designers,
              and digital marketing specialists
              build high-performance digital solutions
              designed to improve visibility,
              increase traffic,
              generate leads,
              and grow online revenue.

            </p>

            <p>

              We specialize in React development,
              Next.js websites,
              Android app development,
              iOS app development,
              cloud software systems,
              and SEO optimization strategies
              that help businesses rank higher on Google.

            </p>

          </div>

        </div>

      </section>

      {/* ====================================
              FAQ
      ==================================== */}
      <section className="py-24 border-b border-white/5">

        <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-10">

          <div className="text-center mb-20">

            <div className="text-indigo-400 uppercase tracking-[0.2em] text-sm font-semibold">
              FAQ
            </div>

            <h2 className="text-4xl sm:text-5xl font-black mt-6">

              Frequently Asked Questions

            </h2>

          </div>

          <div className="space-y-6">

            {faqs.map((faq, i) => (

              <div
                key={i}
                className="bg-[#0E142B] border border-white/10 rounded-3xl p-8 hover:border-indigo-500/20 transition"
              >

                <h3 className="text-2xl font-bold">
                  {faq.q}
                </h3>

                <p className="text-slate-400 leading-8 mt-4">
                  {faq.a}
                </p>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* ====================================
              CTA
      ==================================== */}
      

    </div>
  );
}